import FilterUsersForm from "./users/FilterUsersForm.js";
import FilterAnimeForm from "./anime/FilterAnimeForm.js";
import JSX from "../../helpers/react.js";
import RefObject = JSX.RefObject;

export function FilterBlock({isUsers}: {isUsers: boolean}){
    const el: RefObject={}

    return (
        <form className={`filter-block main bordered-overflow${isUsers?'':' anime'}`} action={isUsers? '/users/filter': '/catalog/filter/'} method="get" ref={el}>
            <div className="filter-content bordered-bottom">{
                isUsers?
                    <FilterUsersForm />:
                    <FilterAnimeForm />
            }</div>
        </form>

    )
}